/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "bvzhphaghrossqcqecsz"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ2emhwaGFnaHJvc3NxY3FlY3N6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMzMjg3MTYsImV4cCI6MjA4ODkwNDcxNn0.5u-Pva2vFn-MeNcU6jwgUr4x3kYdYiZzBiH9bqyXiMc"